import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { HomeContent } from "./components/HomeContent.jsx";
// import { ServicesContent } from "./components/ServicesContent.jsx";
// import { TestimonialsContent } from "./components/TestimonialsContent.jsx";
// import { AboutContent } from "./components/AboutContent.jsx";
// import { ContactContent } from "./components/ContactContent.jsx";
// import { AppFooter } from "./components/common/AppFooter.jsx";
// import { AppHeader } from "./components/common/AppHeader.jsx";

import "./App.css";

function App() {
  return (
    <Router>
      <Helmet>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION} />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-sand">
        {/* Optional: Sticky header */}
        {/* <AppHeader /> */}

        {/* Main content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomeContent />} />
            {/* <Route path="/services" element={<ServicesContent />} /> */}
            {/* <Route path="/testimonials" element={<TestimonialsContent />} /> */}
            {/* <Route path="/about" element={<AboutContent />} /> */}
            {/* <Route path="/contact" element={<ContactContent />} /> */}

            {/* Redirect unknown paths to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        {/* Footer always at the bottom */}
        {/* <AppFooter /> */}
      </div>
    </Router>
  );
}

export default App;
